var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 190.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,34.4l-15.1-2.7-17,96.2,77.1,13.6,5.1-28.8s-24.9,3-43.1-16-18.4-41.6-7-62.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132,108.2c-14-.9-26.5-9.3-32.7-21.9-15-29.9,16.2-45.9,16.2-45.9l27.7,4.9-11.2,62.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.5,110.5l-4.3-.8-8.2,8.1,4,.7,1.6-1.7,6.8,1.2.8,2.1,4.2.7-4.9-10.3ZM63.9,115.5l3-3.2,1.7,4.1-4.7-.9Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "76.8 111.8 91.6 114.4 91.3 116.1 85.8 115.1 84.5 122.7 80.6 122 82 114.4 76.5 113.4 76.8 111.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,118.1c-1.7-1.2-3.7-1.9-5.8-2.2-2-.5-4.2-.5-6.2,0s-3.2,1.6-3.5,3.3c-.3,1.7.4,3.1,2.1,4.3,1.7,1.2,3.7,1.9,5.8,2.2,2,.5,4.2.5,6.2,0s3.1-1.7,3.4-3.3c.4-1.6-.3-3.1-2-4.3M97.1,122.7c-1.2-1-1.3-2.9-.3-4.1.3-.3.7-.6,1.1-.8,2.5-.7,5.2-.2,7.3,1.3,1.2,1.1,1.3,2.9.2,4.1-.3.3-.7.6-1.1.7-1.2.4-2.5.5-3.8.2-1.2,0-2.4-.6-3.4-1.4h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "112.1 127.6 113.7 118.3 117.6 119 116.2 126.6 125.3 128.2 125 129.9 112.1 127.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,182.7C31.2,174.2-1.1,128.1,7.4,79.7S61.9-1,110.3,7.5c48.4,8.5,80.7,54.6,72.2,103h0c-8.5,48.3-54.6,80.6-102.9,72.2ZM1.5,78.6c-9.1,51.7,25.5,100.9,77.1,110s100.9-25.5,110-77.1C197.7,59.8,163.2,10.6,111.5,1.5,59.8-7.6,10.6,26.9,1.5,78.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,112.8c.2.6.4,1.2.7,1.8,1,1.7,2.8,1.9,4.5,1.5,2.2-.6,3.4-2.2,3-3.7l-.5-1.7-7.7,2.1M13.5,115.6c-.1-.7-.2-1.4-.4-2.2s-.5-1.4-.7-2.1l19.3-5.3,1.9,6.9c1.1,3.9,0,6.4-3.1,7.3-5,1.4-7.1-2-8.5-7.1l-8.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,130.2c1.3,2.8,3.3,3.4,5.9,1.8.4-.2.8-.5,1.2-.9,1.8-1.6.5-3.4-.4-4.9l-6.7,4M36.4,121.7l3.1,5.3c.7,1.2,1.8,3,1.9,4.4.2,1.8-.7,3.5-2.3,4.3-2.5,1.4-5,.8-6.8-1.3-1.6,2.8-3,5.7-4.5,8.6l-1,1.9c-.4-.8-.8-1.6-1.2-2.4s-1-1.5-1.5-2.2l3.5-6.1c.5-.8,1.2-2.2,1.8-3.3v-.2c-.1,0-8.2,4.7-8.2,4.7-.3-.7-.6-1.3-1-2s-.8-1.2-1.2-1.8l17.4-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,147.3c-2.5,2.9-3.8,7-.6,9.9s7.8.9,11-2.7c2.5-2.8,4-7.2.7-10.1-3-2.7-6.9-2-11.1,2.9M39.2,158.5c-4.8-4.2-5.6-10-1.3-14.9,3.8-4.4,10.1-5.1,15.5-.3,6.3,5.5,4.2,11.5,1.3,14.9-3.6,4.2-10.1,4.9-15.5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.7,173.1c-.7-.3-1.3-.7-2-1s-1.4-.5-2.1-.7l7.1-16.5c-1.7-.7-3.4-1.3-5.1-1.8.2-.3.4-.7.6-1.1.2-.4.3-.8.4-1.2l13.8,6c-.2.3-.4.7-.6,1.1-.2.4-.3.8-.4,1.2-1.5-.9-3-1.7-4.6-2.4l-7.1,16.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,159.2c0,.4-.3.8-.3,1.2s0,.8,0,1.3c-2.1-.7-4.3-1.2-6.6-1.5l-1,6.2,3,.5c1.2.2,2.4.3,3.6.3,0,.4-.3.8-.3,1.2,0,.4,0,.8,0,1.3-1.1-.4-2.3-.6-3.5-.9l-3-.5-1.2,7.3c2.2.4,4.5.6,6.7.7,0,.4-.3.8-.3,1.2,0,.4,0,.8,0,1.3l-11-1.9,3.3-19.6,10.9,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.2,174.6l-.4,2.6c-1.7,1-3.6,1.7-5.6,1.8-6.2.6-11.3-2.8-11.9-8.7-.7-7.6,4.2-11.6,10.5-12.2,2.1-.2,4.1.1,6.1.9-.2,1-.2,2-.4,3.1h-.4c-1.2-1.5-3.1-2.3-5.1-2.2-4.8.5-6.3,5.3-5.9,9.5.5,5,3.3,8.2,7.7,7.8,1.9-.3,3.7-1.2,5-2.7h.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,172.5c-.7.2-1.4.4-2.1.7s-1.3.6-2,.9l-6.6-16.7c-1.7.7-3.3,1.5-4.9,2.4,0-.4-.2-.8-.3-1.2-.2-.4-.4-.7-.6-1.1l14-5.5c0,.4.2.8.3,1.2.2.4.4.8.6,1.1-1.7.4-3.4.9-5,1.5l6.6,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.9,143.9c.2.4.4.7.6,1.1.3.3.5.7.8.9-2,1-3.9,2.2-5.7,3.6l3.6,5.1,2.5-1.8c1-.7,1.9-1.5,2.8-2.3.2.4.4.8.6,1.1.3.3.5.6.8.9-1.1.5-2.1,1.2-3.1,1.9l-2.5,1.8,4.3,6c1.8-1.3,3.6-2.7,5.3-4.2.2.4.4.8.6,1.1.3.3.5.7.8.9l-9.1,6.4-11.4-16.2,9.1-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.7,149.5l1.5-1.9c2.5-3.2,2.8-6.8-2.5-11-4.3-3.4-7.6-2.7-10.1.5l-1.8,2.2,12.9,10.2M145.9,133.9c4-4.8,9-4.1,12.8-1.1,5.2,4.1,5.4,10.1,1.6,14.8l-5.1,6.3-15.6-12.3,6.3-7.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtolWhite);
export default __webpack_public_path__ + "static/media/atol_white.54dc5b44b0133a2bb9234f0241ae698f.svg";
export { ForwardRef as ReactComponent };